import "smoothscroll-anchor-polyfill";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import smoothscrollPolyfill from "smoothscroll-polyfill";

import components from "./components";
import { init as initComponent } from "./utils/dom";

// Initialise & register all JavaScript components
const init = () => {
	// Polyfill for smooth scroll in Safari
	smoothscrollPolyfill.polyfill();

	// disable gsap warnings for production
	gsap.config({ nullTargetWarn: false });

	// Add scrolltrigger plugin to gsap
	gsap.registerPlugin(ScrollTrigger);

	// Initialise & register all JavaScript components
	initComponent(".js-banner", components.Banner);
	initComponent(".js-hero", components.Hero);
	initComponent(".js-html", components.Html);
	initComponent(".js-card", components.Card);
	initComponent(".js-cards", components.Cards);
	initComponent(".js-contact-info", components.ContactInfo);
	initComponent(".js-detail-header", components.DetailHeader);
	initComponent(".js-intro", components.Intro);
	initComponent(".js-language", components.Language);
	initComponent(".js-fade", components.Fade);
	initComponent(".js-subnav", components.Subnav);
	initComponent(".js-site-hamburger", components.SiteHamburger);
	initComponent(".js-site-header", components.SiteHeader);
	initComponent(".js-site-mobile-menu", components.SiteMobileMenu);
	initComponent(".js-stats", components.Stats);
	initComponent(".js-page-hero", components.PageHero);
	initComponent(".js-youtube", components.Youtube);
};

/**
 * Check if the document is ready to initialise the JavaScript components.
 * Interactive indicates: execute when document has finished loading, but
 * images, stylesheets and frames are still loading.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
 */
document.onreadystatechange = () => {
	if (document.readyState === "interactive") {
		init();
	}
};
